import React, { useState } from 'react';
import { Card, Stack, Cluster, Text, Button, Icon } from '@iqueue/iq-ui';

/** Approval request with the three mandated responses. Library components only. */
export default function ApprovalCard({ approval, onDecide }) {
  const [busy, setBusy] = useState(false);
  const scope = approval.proposed_scope || {};

  const decide = async (decision) => {
    setBusy(true);
    try { await onDecide(approval.id, decision); } finally { setBusy(false); }
  };

  return (
    <Card variant="outlined">
      <Card.Content>
        <Stack gap={100}>
          <Cluster gap={100} align="center">
            <Icon name="lock" size="s" />
            <Text variant="label-medium" render={<span />}>Запрос разрешения</Text>
            <Text variant="label-small" muted render={<span />}>@{approval.requested_by}</Text>
          </Cluster>
          <Text variant="body-medium" emphasized>{approval.action}</Text>
          <Text variant="body-medium" render={<code />}>{approval.target}</Text>
          <Text variant="body-small" muted>{approval.reason}</Text>
          {Array.isArray(scope.permissions) && scope.permissions.length > 0 && (
            <Text variant="body-small" muted>Scope: {scope.permissions.join(', ')}</Text>
          )}
          <Cluster gap={100} justify="end">
            <Button variant="text" disabled={busy} onClick={() => decide('deny')}>Запретить</Button>
            <Button variant="tonal" disabled={busy} onClick={() => decide('allow_always')}>Разрешить всегда</Button>
            <Button disabled={busy} onClick={() => decide('allow_once')}>Разрешить сейчас</Button>
          </Cluster>
        </Stack>
      </Card.Content>
    </Card>
  );
}
